"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var ButtonGroup = function ButtonGroup(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "kuma-button-group"
  }, props.children);
};
ButtonGroup.displayName = 'ButtonGroup';
ButtonGroup.propTypes = {
  children: _propTypes.default.any
};
ButtonGroup.defaultProps = {};
module.exports = ButtonGroup;